document.addEventListener('DOMContentLoaded', () => {
    // 初始化 AOS
    if (typeof AOS !== 'undefined'){
        AOS.init({ once: true });
    } 
  });